import React from "react";
import { Plus, Trash2, Link2 } from "lucide-react";
import { Input } from "../../ui/input";

export const ResourcesEditor = ({ value = [], onChange, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    {value.map((r, i) => (
      <div key={i} className="grid grid-cols-[minmax(140px,1fr)_2fr_auto] gap-2">
        <Input data-testid={`${testid}-title-${i}`} value={r.titulo} placeholder="Nombre (ej. Video tutorial)" onChange={(e) => onChange(value.map((x, j) => (j === i ? { ...x, titulo: e.target.value } : x)))} />
        <Input data-testid={`${testid}-url-${i}`} value={r.url} placeholder="https://… (YouTube, Drive, PDF, página)" onChange={(e) => onChange(value.map((x, j) => (j === i ? { ...x, url: e.target.value } : x)))} />
        <button type="button" data-testid={`${testid}-del-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="p-2 rounded-lg hover:bg-[#FDECEC] text-[#C0392B]"><Trash2 className="w-4 h-4" /></button>
      </div>
    ))}
    <button type="button" data-testid={`${testid}-add`} onClick={() => onChange([...value, { titulo: "", url: "" }])} className="text-xs font-bold text-[#B99B2E] inline-flex items-center gap-1">
      <Link2 className="w-3 h-3" /><Plus className="w-3 h-3" /> Agregar link (video, documento, página)
    </button>
  </div>
);
